import { GN_Carousel } from "./gn_carousel";
import { breakpoints, isBreakpoint } from "../utils";

const SELECTORS = {
  sliderInstance: ".js-series-article__slider",
};

class SeriesCarousel {
  constructor(context) {
    this.context = context;
    this.slider = null;
    this.options = null;
    this.instance = null;
  }

  init() {
    this.slider = this.context.querySelector(SELECTORS.sliderInstance);
    this.options = {
      variableWidth: true,
      watchAria: true,
      watchArrows: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: breakpoints.medium,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        {
          breakpoint: breakpoints.large,
          focusOnSelect: false,
          watchAria: false,
          settings: "unslick",
        },
      ],
    };

    this.instance = new GN_Carousel(this.slider, this.options, this.context);
    this.instance.initCarousel();
    this.subscribe();
  }

  subscribe() {
    // Add resize support
    window.addEventListener("resize", () => {
      if (!isBreakpoint("large")) {
        this.instance.initCarousel();
      }
    });
  }
}

export { SeriesCarousel };
